const STORAGE_KEY = 'recentlyViewedProducts';
const MAX_RECENT_PRODUCTS = 10;

/**
 * Get recently viewed products from localStorage
 */
export const getRecentlyViewed = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading recently viewed products:', error);
    return [];
  }
};

/**
 * Add a product to recently viewed list
 * @param {Object} product - Product object with id, name, brand, image, minPrice, etc.
 */
export const addToRecentlyViewed = (product) => {
  try {
    let recentlyViewed = getRecentlyViewed();

    // Remove existing entry if present (to move to front)
    recentlyViewed = recentlyViewed.filter(p => p.id !== product.id);

    // Add to beginning of array
    recentlyViewed.unshift({
      id: product.id,
      name: product.name,
      brand: product.brand,
      image: product.images?.[0] || null,
      minPrice: product.minPrice,
      maxPrice: product.maxPrice,
      currency: product.currency || 'CZK',
      categorySlug: product.categorySlug,
      brandSlug: product.brandSlug,
      slug: product.slug,
      vendorCount: product.vendorCount,
      viewedAt: new Date().toISOString()
    });

    // Keep only the last N products
    recentlyViewed = recentlyViewed.slice(0, MAX_RECENT_PRODUCTS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));
  } catch (error) {
    console.error('Error saving recently viewed product:', error);
  }
};

/**
 * Clear all recently viewed products
 */
export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing recently viewed products:', error);
  }
};
